module.exports = Jsw.skinUrl + "/images/AI-colored.svg?4098a01d85954db5021a4c49cbaecb9d";